/*
 * Form Container
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'form-container';

export class FormContainer extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        fileUploadContainers: this.element.querySelectorAll('.file-upload__container'),
        submitButton: this.element.querySelector('button[type="SUBMIT"]')
    };

    // Util & State
    hasFileUploads = false;
    customFileList = null;
    formAction = this.element.getAttribute('action');
    redirectPage = this.element.getAttribute('data-redirect');

    digitalData = window.digitalData || [];
    formName = this.element.getAttribute('data-name') || 'default';
    formId = this.element.getAttribute('data-id') || 'default';
    formTitle = this.element.getAttribute('data-title') || 'default';
    formType = this.element.getAttribute('data-type') || 'default';

    /**
     * Send Analytics View
     */
    sendAnalyticsView = () => this.digitalData.push({
        event: 'formView',
        formViewDetail: {
            formName: this.formName,
            formId: this.formId,
            formTitle: this.formTitle,
            formType: this.formType
        }
    });

    /**
     * Send Analytics Submit
     */
    sendAnalyticsSubmit = () => this.digitalData.push({
        event: 'formSubmit',
        formSubmitDetail: {
            formName: this.formName,
            formId: this.formId,
            formTitle: this.formTitle,
            formType: this.formType
        }
    });

    /**
     * Check for File Upload Fields
     */
    checkForUploadFields = () => this.hasFileUploads = this.elements.fileUploadContainers.length > 0;

    /**
     * Handle File Uploads and Submit the Form
     */
    handleFileUploadsAndSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(this.element);

        // Handle File Upload content
        if(this.customFileList !== null && this.customFileList.length > 0) {
            this.customFileList.map((file) => formData.append('file', file, file.name));

            // //Uncomment Block to Debug FormData values
            // for (var [key, value] of formData.entries()) {//eslint-disable-line
            //     console.log(key, value);//eslint-disable-line
            // }
        }

        // Show Loader
        window.dispatchEvent(new CustomEvent('show-loading', null));

        // Make AJAX Call
        fetch(this.formAction, {
            method: 'POST',
            body: formData
        }).then((response) => {
            if(!response.ok) {
                throw new Error('Response failed');
            }
            return response;
        }).then((response) => {
            if(response && response.status === 200) {
                // Analytics
                this.sendAnalyticsSubmit();

                // Redirect User
                window.location.href = this.redirectPage || window.location.href;
            } else {
                this.element.classList.add('error');
                window.dispatchEvent(new CustomEvent('hide-loading', null));
            }
        }).catch((error) => {
            console.warn(error);//eslint-disable-line
            this.element.classList.add('error');
            window.dispatchEvent(new CustomEvent('hide-loading', null));
        });
    };

    /**
     * Handle Validation
     */
    handleValidation = (e) => {
        let hasError = false;
        const requiredFields = this.element.querySelectorAll('[data-required]');

        [...requiredFields].map((fieldEle) => {
            const isText = fieldEle.classList.contains('form-text__input') || fieldEle.classList.contains('form-text__textarea');
            const isCheckbox = fieldEle.classList.contains('cmp-form-options--checkbox');
            const isRadio = fieldEle.classList.contains('cmp-form-options--radio');
            const isSingleSelect = fieldEle.classList.contains('cmp-form-options--drop-down');
            const isMultiSelect = fieldEle.classList.contains('cmp-form-options--multi-drop-down');
            const isUpload = fieldEle.classList.contains('file-upload__container');

            // Text Fields
            if(isText) {
                const inputValue = fieldEle.value;
                const isEmpty = inputValue === '';
                const parentContainerEle = fieldEle.closest('.form-text');

                if(isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add('error');
                } else {
                    parentContainerEle.classList.remove('error');
                }
            }

            // Checkboxes & Radios
            if(isCheckbox || isRadio) {
                const parentContainerEle = fieldEle.closest('.options');
                const inputEles = fieldEle.querySelectorAll('input');
                let isEmpty = true;

                [...inputEles].map((inputEle) => {//eslint-disable-line
                    if(inputEle.checked === true) isEmpty = false;
                });

                if(isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add('error');
                } else {
                    parentContainerEle.classList.remove('error');
                }
            }

            // Selects
            if(isSingleSelect || isMultiSelect) {
                const isEmpty = fieldEle.querySelectorAll('option[selected]:not([value="placeholder"]').length === 0;
                const parentContainerEle = fieldEle.closest('.options');

                if(isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add('error');
                } else {
                    parentContainerEle.classList.remove('error');
                }
            }

            // File Upload
            if(isUpload) {
                const isEmpty = fieldEle.getAttribute('data-total-files') === '0';
                const parentContainerEle = fieldEle.closest('.file-upload');

                if(isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add('error');
                } else {
                    parentContainerEle.classList.remove('error');
                }
            }

            return false;
        });

        if(this.elements.submitButton) this.elements.submitButton.blur();

        if(hasError) {
            this.element.classList.add('error');
            return false;
        }

        this.element.classList.remove('error');
        return this.handleFileUploadsAndSubmit(e);
    };

    /**
     * On Form Submit
     */
    onFormSubmit = (e) => {
        e.preventDefault();
        this.handleValidation(e);
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.element.addEventListener('submit', this.onFormSubmit);
        window.addEventListener('file-upload-data', (e) => {
            if(e.detail && e.detail.customFileList) {
                this.customFileList = e.detail.customFileList;
            }
        });
    };

    /**
     * Initialize Component
     */
    init() {
        this.sendAnalyticsView();
        this.checkForUploadFields();
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, FormContainer);
